<template>
	<div

		class="news-feed-empty__container elevation-0 d-flex flex-column"
		:class="{ 'mx-auto': this.centering === 'center' }"
	>
		<div class="mx-auto" style="margin-top: 150px">
			<img :src="NewsFeedEmpty" alt="noResultSearchImage" class="news-feed-empty__banner" />
		</div>

		<div class="news-feed-empty__title">{{this.title}}</div>

		<div class="news-feed-empty__description">{{this.description}}</div>
	</div>
</template>

<script>
import NewsFeedEmpty from '@/assets/images/NewsFeedEmpty.png'

export default {
	name: 'NewsFeedEmpty',
	data() {
		return {
			NewsFeedEmpty,
		}
	},
	props: {
		title: {
			type: String,
			default: '',
		},
		description: {
			type: String,
			default: ''
		},
		centering: {
			type: String,
			default: 'left'
		}
	},
}
</script>

<style lang="scss">

.news-feed-empty {
	&__container {
		width: 600px;
		height: 778px;
		border-radius: 10px !important;
		box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.06);
		background: white !important;
		padding: 45px 100px 60px 100px;
	}

	&__banner {
		width: 272px;

	}

	&__title {
		color: rgb(74, 74, 74);
		font-size: 18px;
		font-family: Montserrat, sans-serif;
		font-weight: bold;
		text-align: center;
		letter-spacing: 0px;
		line-height: 22px;
		margin-top: 30px;
		margin-bottom: 12px;
	}

	&__description {
		color: rgb(74, 74, 74);
		font-size: 15px;
		font-family: Montserrat, sans-serif;
		font-weight: normal;
		text-align: center;
		line-height: 18px;
	}

	@media screen and (min-width: 1264px) {
		&__container {
			max-width: 600px;
		}
	}
	@media screen and (max-width: 480px) {
		&__container {
			width: 100%;
			padding: 15px;
		}
	}
}
</style>
